import React from 'react'

export default function TestnetBox(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#747894" {...props}>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.27 6.96L12 12.01l8.73-5.05" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 22.08V12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
